export enum CalendarScreenTypeEnum {
    Calendar = "Calendar",
    Schedule = "Schedule",
}
